import React, { useState } from 'react';
import styled from 'styled-components';

import { Command, tabActions } from '@store/index';
import { Card } from '@common/Card';
import { FormatColorTextOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useTheme } from '../../../../styles';
import { NodeInputExpression } from '../NodeInput';
import { NodeField } from '@components/Flow/Nodes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0.35rem;
  gap: 0.5rem;
`;

interface Props {
  command: Command;
  field: NodeField;
}

export const CustomOutput: React.FC<Props> = ({ command, field }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const state = command.state[field.id];
  const output = state.output;
  const enabled = state.enabled;

  const [collapsed, setCollapsed] = useState(!enabled);

  const toggleEnabled = (newVal: boolean) => {
    dispatch(tabActions.setSaved(false));

    dispatch(
      tabActions.nodeInputNestedUpdate({
        nodeId: command.node.id,
        fieldId: field.id,
        nestedFieldName: 'enabled',
        value: newVal,
      })
    );

    if (newVal) setCollapsed(false);
  };

  const tooltip = `Write the text output you want the LLM to read after this tool is executed. You can use dynamic variables to create dynamic outputs.`;

  const body = (
    <Container>
      <NodeInputExpression
        field={field}
        command={command}
        allowToolArgs
        override={{
          title: 'Tool Text Output',
          tooltip: tooltip,
          placeholder: 'Text the LLM will read after executing this tool.',
          value: output,
          update: (fieldName, value) => {
            dispatch(
              tabActions.nodeInputNestedUpdate({
                nodeId: command.node.id,
                fieldId: field.id,
                nestedFieldName: 'output',
                fieldName,
                value,
              })
            );
          },
        }}
      />
    </Container>
  );

  return (
    <Card
      title='Custom Output'
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      enabled={enabled}
      setEnabled={toggleEnabled}
      icon={<FormatColorTextOutlined sx={{ fontSize: '2.3ch', color: theme.telnyx.blue }} />}
      description={field.description}
      descriptionBorder
      body={body}
    />
  );
};
